import * as R from 'ramda';

export const getLevelSections = R.propOr([], 'content');
